// extracted by mini-css-extract-plugin
export default {"brandPromo":"QF-z","carousel":"RF-z"};